import React, { useEffect, useState } from 'react';
import FormFields from '../../../Forms/FormFields';
import './FacilityDetails.css';
import Button from '../../../../components/common/Button';
import PlusSvgIcon from './../../../../assets/svg/plus.svg';
import HFRVerify from './HFRVerify';
import axios from '../../../../utils/axiosExt';
import endpoints from '../../../../config/endpoints';
import calculateSimilarity  from '../../../../utils/fuzzyLogic'
import Auth from "../../../../utils/auth";
import { errorLogger } from '@utils/applicationLogUtils';

type propsType = {
  formData: {
    [key: string]: any;
  };
  formState: any;
  handleFormChange: (value: string | boolean, key: string, id: any, code?:any) => void;
  handleFacilityData:any;
  handleHfrIdvalidationBeforeVerify: (state: any, key: string) => void;
};

const FacilityDetails = ({ formData, formState, handleFormChange, handleFacilityData, handleHfrIdvalidationBeforeVerify }: propsType) => {
  const [verify, setVerify] = useState<boolean>(false);
  const [showVerifyLabel, setShowVerifyLabel] = useState<boolean>(false);
  const [clickVerify, setClickVerify] = useState<boolean>(false);
  const [facilityData, setFacilityData] = useState<any>({});
  const [matchingScore, setMatchingScore] = useState<number>(0);

  const calulateMatchingScore =()=>{    
        if(formState.hpr_id.value){
          const enteredFCName = formState.facility_name.value;
          const ABDMFCName = facilityData.facilityName;  
          const result = calculateSimilarity(enteredFCName, ABDMFCName)
          setMatchingScore(result);
          if(result < 70)
            {
              // formState.facility_name.isError = true;
              // formState.facility_name.message = 'Matchine score <70 %.';
              handleHfrIdvalidationBeforeVerify({
                isError: true,
                message: 'ABDM matching score is less than 70%.'
              }, 'facility_name');
    
            }
          else{
            handleHfrIdvalidationBeforeVerify({
              isError: false,
              message: ''
            }, 'facility_name');
          }
        }
  }

  useEffect(()=>{
    if (facilityData.facilityName) {
      calulateMatchingScore();
    }
  },[facilityData]);


  const onClickVerify = async () => {
    try {
      if (formState?.hpr_id?.value) {
        if(formState.facility_name.value.length === 0){
          handleHfrIdvalidationBeforeVerify({
            isError: true,
            message: 'Enter facility name to continue.'
          }, 'facility_name');
        }
        else if(!/^[a-zA-Z0-9\s.,\-@#$%&*!+?():'"/]+$/.test(formState.facility_name.value)){
          handleHfrIdvalidationBeforeVerify({
            isError: true,
            message: 'Health Facility Name cannot have special characters.'
          }, 'facility_name');
        }
        if(formState.facility_name.value.length > 500){
          handleHfrIdvalidationBeforeVerify({
            isError: true,
            message: 'Health Facility Name cannot more than 500 letters.'
          }, 'facility_name');
        }
        if(formState?.hpr_id?.value ==='000000000000'){
          handleHfrIdvalidationBeforeVerify({
            isError: true,
            message: 'Enter Valid HFR ID.'
          }, 'hpr_id');
        }
        if(!/^\w{12}$/.test(formState?.hpr_id?.value)){
          handleHfrIdvalidationBeforeVerify({
            isError: true,
            message: 'Enter Valid HFR ID.'
          }, 'hpr_id');
        }
        if(formState.facility_name.value.length >0)
        {
          const facilityId = formState?.hpr_id?.value;
          const ifHfrExist = await axios.get(`${endpoints.getABDMDetails(facilityId)}`, Auth.loggedIn());
          if (ifHfrExist.status === 200) {
            if (ifHfrExist.data.data.length > 0) {
              setVerify(false);
              setClickVerify(false);
              handleHfrIdvalidationBeforeVerify({
                isError: true,
                message: 'The HFR ID is already associted with another facility.'
              }, 'hpr_id');
            } else {
              const response = await axios.post(`${endpoints.verifyHFR}`, { facilityId }, Auth.loggedIn());
              if (response.status === 200) {
                const facilities = response?.data.data?.facilities;
                if (facilities.length > 0) {
                  const facility = facilities[0];
                  const userStateCode = localStorage.getItem("userStateCode");
                  const userDistrictCode = localStorage.getItem("userDistrictCode");
                  if(userStateCode === "null" && userDistrictCode === "null"){
                    setFacilityData(facility);
                      setClickVerify(true);
                      setVerify(true);
                      handleHfrIdvalidationBeforeVerify({
                        isError: false,
                        message: '',
                        verifiedDetails:''
                      }, 'hpr_id'); 
                  }else if(userStateCode !=="null" && userDistrictCode === "null"){
                    if((Number(userStateCode) === Number(facility.stateLGDCode))){
                      setFacilityData(facility);
                      setClickVerify(true);
                      setVerify(true);
                      handleHfrIdvalidationBeforeVerify({
                        isError: false,
                        message: '',
                        verifiedDetails:''
                      }, 'hpr_id'); 
                    }else{
                      setVerify(false);
                      handleHfrIdvalidationBeforeVerify({
                      isError: true,
                      message: 'Entered HFR ID cannot be of different state'
                    }, 'hpr_id');
                    }
                  }
                  else if(userStateCode !=="null" && userDistrictCode !== "null")
                  {
                    if((Number(userStateCode) === Number(facility.stateLGDCode)) && Number(userDistrictCode) === Number(facility.districtLGDCode)){
                      setFacilityData(facility);
                      setClickVerify(true);
                      setVerify(true);
                      handleHfrIdvalidationBeforeVerify({
                        isError: false,
                        message: '',
                        verifiedDetails:''
                      }, 'hpr_id'); 
                    }else{
                      setVerify(false);
                      handleHfrIdvalidationBeforeVerify({
                      isError: true,
                      message: 'Entered HFR ID cannot be of different state or district'
                    }, 'hpr_id');
                    }
                  }
                }
                else{
                  setVerify(false);
                  handleHfrIdvalidationBeforeVerify({
                    isError: true,
                    message: 'Enter Valid HFR ID.'
                  }, 'hpr_id');
                }
              } else {
                errorLogger(`Matching HFRID not found in ABDM: ${response.status}`)
                setClickVerify(false);
                handleHfrIdvalidationBeforeVerify({
                  isError: true,
                  message: 'Enter Valid HFR ID.'
                }, 'hpr_id');
              }
            }
          } else {
            errorLogger(`Error while checking HFR exist or not:  ${ifHfrExist.status}`)
          }
       }
      }
    } catch (error: any) {
       setVerify(false);
      if (axios?.isAxiosError(error)) {
        errorLogger(`Axios error: ${error.message}`)
        if (error.response) {
          errorLogger(`Error response: ${error.response.status}`)
          if (error.response.status === 500) {
            errorLogger(`Server error: ${error.response.data}`)
          }
        }
      } else {
        errorLogger(`Unknown error: ${error}`)
      }
    }
  }

  const closeVerifyModal = (overwriteFacilityName: boolean = false) => {
    setClickVerify(false);
    handleFacilityData(facilityData, overwriteFacilityName);
    setVerify(true);
    setShowVerifyLabel(true);
  }

  const onClickNext = (accept: any) => {
    if (accept) {
      closeVerifyModal(accept);
    } else {
      closeVerifyModal();
    }
  }

  return (
    <div className="create_facility_details_page">
      <form className="form_container_facility_details">
        <FormFields
          formData={formData}
          formState={formState}
          handleFormChange={(value: any, key: string, id: any, option: any, code:any) => {
            if(key === 'facility_category') {
            id =[];
              option.length > 0  && value.length > 0 && option.forEach((op:any) => {
                if(value.includes(op.value)) {
                  id.push(op.id);
                }
            });
            code= [];
            option.length > 0  && value.length > 0 && option.forEach((op:any) => {
              if(value.includes(op.value)) {
                code.push(op.code);
              }
            });
            }
            if(key == 'hpr_id' || key == 'facility_name')
              {
                setVerify(false);
                setClickVerify(false);
                setShowVerifyLabel(false);
                formState.hpr_id.verifiedDetails = 'not verified';
              }
            handleFormChange(value, key, id, code);
          }}
          verified={verify}
          onClickVerify={onClickVerify}
          showVerifyLabel={showVerifyLabel}
          //message={isMessage}
        />
      </form>
      {verify && clickVerify &&
        <HFRVerify
          closeVerifyModal={closeVerifyModal}
          facilityVerify={facilityData}
          matchingScore={matchingScore}
          onClickNext={onClickNext}          
        />
      }
    </div>
  );
};
export default FacilityDetails;
